import { TimezonePipe } from './../../../common/pipes/timezone.pipe';
import { KPI } from './../planner-edit/constants/KPI.const';
import { MediaChannel } from './../../constants/media-channel.const';
import { Component, Input, OnInit } from '@angular/core';
import { TableConfigs, ToolBarConfigs } from 'src/app/common/components/data-table/data-table.component';
import { PlannerEndpoints } from '../../constants/planner-endpoints.const';
import { ListActionsService } from '../../services/list-actions.service';
import { DealType } from '../../constants/publisher-deal-type.const';
import * as _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { CurrencyPipe, DecimalPipe, PercentPipe } from '@angular/common';

@Component({
  selector: 'deal-list',
  templateUrl: './deal-list.component.html',
  styleUrls: ['./deal-list.component.scss']
})
export class DealListComponent implements OnInit {

  @Input('advertiserInfo') public advertiserInfo: any;

  constructor(
    private listActionService: ListActionsService,
    private timezonePipe: TimezonePipe,
    private route: ActivatedRoute,
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe,
    private percentPipe: PercentPipe
  ) { }

  ngOnInit() {
  }

  public mediaChannel = MediaChannel;
  public dealType = DealType;

  public tableConfigs: TableConfigs = {
    disableSorting: true,
    uniqueIdAccessor: 'publisherDealId',
    pageSize: 25,
    isSelectionEnabled: false,
    isPaginationEnabled: true,
    showSummaryRow: false,
    stickyHeader: true,
    stickyColumnHeaders: true,
    endpoint: PlannerEndpoints.dspDeals,
    showCallToAction: true,
    callToActionProps: {
      type: 'EmptyTable',
      title: 'No Deals Found'
    }
  };
  public columns: any[] = [
    {
      Header: 'Name',
      accessor: 'name',
      id: 'name',
      sticky: 'left'
    },
    {
      Header: 'Publisher Deal ID',
      accessor: 'publisherDealId',
      id: 'publisherDealId',
      disableSortBy: true
    },
    {
      Header: 'Deal Type',
      accessor: row => {
        let obj = _.find(this.dealType, { id: row.dealType });
        return obj && obj.description || '-'
      },
      id: 'dealType',
      disableSortBy: true
    },
    {
      Header: 'Deal Id',
      accessor: 'dealId',
      id: 'dealId',
      disableSortBy: true
    },
    {
      Header: 'Format',
      accessor: row => {
        let obj = _.find(this.mediaChannel, { id: row.mediaChannelId });
        return obj && obj.label || '-';
      },
      id: 'mediaChannelId',
      disableSortBy: true
    },
    {
      Header: 'Inventory Source',
      accessor: 'invSource',
      id: 'invSource',
      disableSortBy: true
    },
    {
      Header: 'Publisher',
      accessor: 'publisher',
      id: 'publisher',
      disableSortBy: true
    },
    {
      Header: 'Floor Price',
      accessor: 'price',
      id: 'price',
      disableSortBy: true
    },
    {
      Header: 'Currency',
      accessor: 'localCurrency',
      id: 'localCurrency',
      disableSortBy: true
    },
    {
      Header: 'Start Date',
      id: 'startDate',
      accessor: row => {
        return this.timezonePipe.transform(row.startDate, undefined, row.marketTimeZone);
      },
      disableSortBy: true
    },
    {
      Header: 'Live Status',
      accessor: 'liveStatus',
      id: 'liveStatus',
      disableSortBy: true
    },
    {
      Header: 'Bid Request',
      accessor: row => {
        return this.decimalPipe.transform(row.bidRequest > -1 ? row.bidRequest : 0);
      },
      id: 'bidRequest',
      disableSortBy: true
    },
    {
      Header: 'Estimated Bids',
      accessor: row => {
        return this.decimalPipe.transform(row.bids > -1 ? row.bids : 0);
      },
      id: 'bids',
      disableSortBy: true
    },
    {
      Header: 'Win Rate',
      accessor: row => {
        return this.percentPipe.transform(row.bidWinPercent > -1 ? row.bidWinPercent / 100 : 0, '1.0-2');
      },
      id: 'bidWinPercent',
      disableSortBy: true
    },
    {
      Header: 'eCPM',
      accessor: row => {
        if (row.ecpm) {
          return this.currencyPipe.transform(row.ecpm > -1 ? row.ecpm : 0, row.localCurrency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'ecpm',
      disableSortBy: true
    },
    {
      Header: 'eCPC',
      accessor: row => {
        if (row.ecpm) {
          return this.currencyPipe.transform(row.ecpc > -1 ? row.ecpc : 0, row.localCurrency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'ecpc',
      disableSortBy: true
    },
    {
      Header: 'eCPA',
      accessor: row => {
        if (row.ecpm) {
          return this.currencyPipe.transform(row.ecpa > -1 ? row.ecpa : 0, row.localCurrency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'ecpa',
      disableSortBy: true
    },
    {
      Header: 'CTR',
      accessor: row => {
        return this.percentPipe.transform(row.ctr > -1 ? row.ctr / 100 : 0, '1.0-2');
      },
      id: 'ctr',
      disableSortBy: true
    },
    {
      Header: 'CTA',
      accessor: row => {
        return this.decimalPipe.transform(row.cta > -1 ? row.cta : 0);
      },
      id: 'cta',
      disableSortBy: true
    },
    {
      Header: 'VTA',
      accessor: row => {
        return this.decimalPipe.transform(row.vta > -1 ? row.vta : 0);
      },
      id: 'vta',
      disableSortBy: true
    },
    {
      Header: 'In-View Rate',
      accessor: row => {
        return this.percentPipe.transform(row.inViewRate > -1 ? row.inViewRate / 100 : 0, '1.0-2');
      },
      id: 'inViewRate',
      disableSortBy: true
    },
    {
      Header: 'Completion Rate',
      accessor: row => {
        return this.percentPipe.transform(row.completionRate > -1 ? row.completionRate / 100 : 0, '1.0-2');
      },
      id: 'completionRate',
      disableSortBy: true
    },
    {
      Header: 'Impressions',
      accessor: row => {
        return this.decimalPipe.transform(row.pubDealImpressions > -1 ? row.pubDealImpressions : 0);
      },
      id: 'pubDealImpressions',
      disableSortBy: true
    },
    {
      Header: 'MTA Actions',
      accessor: row => {
        return this.decimalPipe.transform(row.mtaActions > -1 ? row.mtaActions : 0);
      },
      id: 'mtaActions',
      disableSortBy: true
    },
    {
      Header: 'MTA eCPA',
      accessor: row => {
        if (row.ecpm) {
          return this.currencyPipe.transform(row.mtaEcpa > -1 ? row.mtaEcpa : 0, row.localCurrency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'mtaEcpa',
      disableSortBy: true
    },
    {
      Header: 'TPA Impressions',
      accessor: row => {
        return this.decimalPipe.transform(row.tpaImpressions > -1 ? row.tpaImpressions : 0);
      },
      id: 'tpaImpressions',
      disableSortBy: true
    },
    {
      Header: 'TPA Clicks',
      accessor: row => {
        return this.decimalPipe.transform(row.tpaClicks > -1 ? row.tpaClicks : 0);
      },
      id: 'tpaClicks',
      disableSortBy: true
    },
    {
      Header: 'TPA Actions',
      accessor: row => {
        return this.decimalPipe.transform(row.tpaActions > -1 ? row.tpaActions : 0);
      },
      id: 'tpaActions',
      disableSortBy: true
    },
    {
      Header: 'TPA eCPM',
      accessor: row => {
        if (row.ecpm) {
          return this.currencyPipe.transform(row.tpaEcpm > -1 ? row.tpaEcpm : 0, row.localCurrency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'tpaEcpm',
      disableSortBy: true
    },
    {
      Header: 'TPA eCPC',
      accessor: row => {
        if (row.ecpm) {
          return this.currencyPipe.transform(row.tpaEcpc > -1 ? row.tpaEcpc : 0, row.localCurrency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'tpaEcpc',
      disableSortBy: true
    },
    {
      Header: 'TPA eCPA',
      accessor: row => {
        if (row.ecpm) {
          return this.currencyPipe.transform(row.tpaEcpa > -1 ? row.tpaEcpa : 0, row.localCurrency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'tpaEcpa',
      disableSortBy: true
    },
    {
      Header: 'TPA MTA Actions',
      accessor: row => {
        return this.decimalPipe.transform(row.thirdPartyMtaActions > -1 ? row.thirdPartyMtaActions : 0);
      },
      id: 'thirdPartyMtaActions',
      disableSortBy: true
    },
    {
      Header: 'TPA MTA eCPA',
      accessor: row => {
        if (row.ecpm) {
          return this.currencyPipe.transform(row.thirdPartyMtaEcpa > -1 ? row.thirdPartyMtaEcpa : 0, row.localCurrency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'thirdPartyMtaEcpa',
      disableSortBy: true
    }
  ];

  public toolbarConfigs: ToolBarConfigs = {
    isSearchEnable: true,
    toolbarOptions: {
      isRefreshVisible: true
    },
    filterSetup: [
      {
        label: 'Inventory Source',
        name: 'invSrcId',
        options: this.route.snapshot.data.currentInventorySources,
        initialValue: this.route.snapshot.data.currentInventorySources[0].name
      },
      /*
      {
        label: 'Format',
        name: 'mediaChannelId',
        options: this.listActionService.getOptionsFromConst(MediaChannel, 'id', 'label'),
        initialValue: MediaChannel.Display.id
      },*/
      {
        label: 'Type',
        name: 'dealTypeIds',
        options: this.listActionService.getOptionsFromConst(DealType, 'id', 'description'),
        initialValue: DealType.PrivateAuction.id
      },
      {
        label: 'Amobee Preferred Deal',
        name: 'isAmobeePreferred',
        options:
          [
            { label: 'Yes', name: 'true' },
            { label: 'No', name: 'false' }
          ],
        initialValue: 'true'
      },
      {
        label: 'KPI',
        name: 'kpiIds',
        options: this.listActionService.getOptionsFromConst(KPI, 'id', 'label'),
        initialValue: KPI.Viewability.id
      }
    ]
  }

}
